import * as React from "react";
import * as R from "ramda";
import {Button, Col, Glyphicon, Row} from "react-bootstrap";
import {Form} from "react-final-form";
import ModalConfirmacion from "../../../general/componentes/ModalConfirmacion";
import {recibirDocumentos} from "../../modulos/documentosActions";
import Oficinas from "../../../general/componentes/Oficinas";
import {connect} from "react-redux";

class ModalRecepcion extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleClose() {
        this.setState({show: false});
    }

    handleShow() {
        this.setState({show: true});
    }

    render() {
        return (
            <div>
                <Row>
                    <a title={"RECIBIR"} className={"btns btns-primary"}
                       onClick={() => this.handleShow()}><Glyphicon glyph={"ok"}/></a>
                </Row>
                <Row>
                    <ModalConfirmacion titulo={"Recibir Documentos"} show={this.state.show}
                                       onCancelar={() => this.handleClose()}>
                        <Form
                            onSubmit={this.recepcionDocumental}
                            validate={this.validate}
                            render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                                <form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col smOffset={3} sm={6}>
                                            <label>Oficina</label>
                                            <Oficinas name={"oficina"}/>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col smOffset={5} sm={3}>
                                            <Button type="submit" className="btns btns-primary"
                                                    disabled={submitting || invalid}>
                                                Recibir
                                            </Button>
                                        </Col>  
                                    </Row>
                                </form>
                            )}
                        />
                    </ModalConfirmacion>
                </Row>
            </div>
        );
    }

    recepcionDocumental = (values) => {
        this.handleClose(); 
        this.props.dispatch(recibirDocumentos(
            this.props.dni,
            this.props.tipoCliente,
            values.oficina,
            this.props.dniLogin));
    };

    validate = values => {

        const errors = {oficina: undefined};

        if (!values.oficina || values.oficina === "Selecciona...") {
            errors.oficina = "Por favor seleccione una oficina";
        }

        return errors;
    }
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        dniLogin: R.pathOr("", ["inicio", "dniLogin"])(store)
    };
})(ModalRecepcion);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/recepcion/ModalRecepcion.tsx